var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBCartSell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-cart-sell",
    x: 0,
    y: 0.002,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconB-cart-sell1",
    serifid: "iconB-cart-sell"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.864,2.011c0.35,0 0.581,0.179 0.688,0.284l0.002,0.002l2.508,2.51c0.176,0.175 0.284,0.418 0.284,0.687c0,0.537 -0.435,0.972 -0.971,0.972c-0.269,-0 -0.512,-0.109 -0.688,-0.285l-0.851,-0.852l-0,4.238c-0,0.537 -0.435,0.972 -0.972,0.972c-0.537,0 -0.972,-0.435 -0.972,-0.972l-0,-4.238l-0.852,0.852c-0.176,0.176 -0.419,0.285 -0.687,0.285c-0.537,-0 -0.972,-0.435 -0.972,-0.972c0,-0.269 0.109,-0.512 0.285,-0.687c-0,-0 2.508,-2.508 2.508,-2.508c0.117,-0.125 0.301,-0.288 0.69,-0.288Zm-3.371,12.95l10.557,-2.533l0,-5.925l-1.293,-0.002c-0.542,-0 -0.981,-0.44 -0.981,-0.981c-0,-0.542 0.439,-0.982 0.981,-0.982l2.05,0c0.653,-0 1.246,0.62 1.246,1.238c-0,0.012 -0.004,5.503 -0.004,7.131c0,1.045 -0.869,1.287 -1.118,1.352c-0.002,0.001 -0.004,0.001 -0.006,0.002c0,-0 -10.854,2.687 -11.731,2.887c-0.222,0.051 -0.383,0.015 -0.427,0.008c-0.512,-0.08 -0.701,-0.522 -0.729,-0.583c-0.161,-0.355 -4.771,-10.06 -5.337,-11.598c-0.473,-0.003 -1.731,-0.01 -1.734,-0.01c-1.3,-0 -1.27,-1.968 0,-1.968c0.482,-0 2.639,0.012 2.639,0.012c0,-0 0.688,-0.005 0.933,0.666c0.205,0.558 0.263,0.715 0.319,0.863c0.14,0 0.965,0.001 2.173,0.001c0.543,-0 0.984,0.441 0.984,0.984c-0,0.543 -0.441,0.985 -0.984,0.985c0,-0 -1.461,0.001 -1.461,0.001c0.513,1.379 3.283,7.127 3.836,8.271c0.043,0.09 0.073,0.152 0.087,0.181Zm-4.493,2.04c1.104,0 2,0.897 2,2c-0,1.104 -0.896,2 -2,2c-1.104,0 -2,-0.896 -2,-2c-0,-1.103 0.896,-2 2,-2Zm11.742,0c1.104,0 2,0.897 2,2c0,1.104 -0.896,2 -2,2c-1.104,0 -2,-0.896 -2,-2c0,-1.103 0.896,-2 2,-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBCartSell);
export default __webpack_public_path__ + "static/media/iconB-cart-sell.9d621dc88a35c3e64f475f997055100c.svg";
export { ForwardRef as ReactComponent };